import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from 'shared/shared.module';

import { BaseSegmentComponent } from './components/base/_base-segment.component';

// components
import { ProductGroupsComponent } from './components/product-groups/product-groups.component';
import { ProductGroupsFormComponent } from './components/product-groups/product-groups-form.component';
import { MarketingComponent } from './components/marketing/marketing.component';
import { MarketingFormComponent } from './components/marketing/marketing-form.component';
import { PriceSheetsComponent } from './components/price-sheets/price-sheets.component';
import { PriceSheetsFormComponent } from './components/price-sheets/price-sheets-form/price-sheets-form.component';
import { CoreComponent } from './components/core/core.component';
import { CoreFormComponent } from './components/core/core-form.component';

// service
import { BrandInformationService } from './brand-information.service';
import {HttpClientModule} from '@angular/common/http';
import {ProductDetailsV2Module} from '../../product-details-v2/product-details.module';


@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    SharedModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    // TypeaheadModule.forRoot(),
    ProductDetailsV2Module,
  ],
  declarations: [
    BaseSegmentComponent,

    ProductGroupsComponent,
    ProductGroupsFormComponent,
    MarketingComponent,
    MarketingFormComponent,
    PriceSheetsComponent,
    PriceSheetsFormComponent,
    CoreComponent,
    CoreFormComponent,
  ],
  exports: [],
  providers: [
    BrandInformationService,
  ],
})
export class BrandInformationModule {}
